<template>
  <div style="padding:6px;min-width:220px">
    <el-input
      v-model="search"
      size="mini"
      clearable
      placeholder="Search…"
      style="margin-bottom:6px"
    />
    <div style="max-height:180px;overflow:auto">
      <el-checkbox-group v-model="pending">
        <el-checkbox
          v-for="v in filteredOptions"
          :key="v"
          :label="v"
          style="display:block;margin:2px 0"
        >{{ v }}</el-checkbox>
      </el-checkbox-group>
    </div>
    <div style="margin-top:6px;display:flex;gap:6px;flex-wrap:wrap">
      <el-button size="mini" @click="onSelectAll">All</el-button>
      <el-button size="mini" @click="onSelectNonZero">Non-zero</el-button>
      <el-button size="mini" @click="onClear">Clear</el-button>
      <el-button size="mini" type="primary" @click="onApply" style="margin-left:auto">Apply</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuantitySetFilter',
  data() {
    return { params:null, field:null, options:[], search:'', pending:[], applied:[] }
  },
  computed: {
    filteredOptions() {
      var s = (this.search || '').trim()
      return s ? this.options.filter(function(v){ return String(v).indexOf(s) !== -1 }) : this.options
    }
  },
  methods: {
    // Build unique numeric values from currently displayed rows (respects other filters)
    buildOptions() {
      if (!this.params || !this.params.api) return
      var api = this.params.api
      var field = this.field
      var set = Object.create(null)

      // Use "afterFilter" so we respect other active column filters
      api.forEachNodeAfterFilter(function(node) {
        if (!node || !node.data) return
        var val = node.data[field]
        if (val === null || val === undefined) return
        var num = Number(val)
        if (!isNaN(num)) set[num] = true
      })

      // Fallback: if nothing yet (e.g., opened very early), scan all nodes
      if (Object.keys(set).length === 0) {
        api.forEachNode(function(node) {
          if (!node || !node.data) return
          var val = node.data[field]
          if (val === null || val === undefined) return
          var num = Number(val)
          if (!isNaN(num)) set[num] = true
        })
      }

      var arr = Object.keys(set).map(function(k){ return Number(k) }).sort(function(a,b){ return a-b })
      this.options = arr
      // keep pending selection consistent if options changed (avoid stale values)
      this.pending = this.pending.filter(function(v){ return set[String(v)] || set[v] })
    },

    // AG Grid lifecycle
    init(params) {
      this.params = params
      this.field = params.colDef.field
      this.buildOptions()
    },
    afterGuiAttached() {
      // In case the filter opens before data settled
      this.buildOptions()
    },
    onNewRowsLoaded() {
      // When grid data changes, refresh the list
      this.buildOptions()
    },

    // Filter API
    isFilterActive() { return this.applied.length > 0 },
    doesFilterPass(node) {
      if (!this.applied.length) return true
      var d = node && node.data ? node.data : {}
      var v = Number(d[this.field])
      // NaN never matches
      if (isNaN(v)) return false
      return this.applied.indexOf(v) !== -1
    },
    getModel() {
      return this.applied.length ? { type: 'valueSet', values: this.applied.slice() } : null
    },
    setModel(m) {
      var vals = (m && m.values && Array.isArray(m.values)) ? m.values.slice() : []
      this.applied = vals
      this.pending = vals.slice()
    },

    // Buttons
    onApply() {
      this.applied = this.pending.slice()
      if (this.params && this.params.filterChangedCallback) this.params.filterChangedCallback()
    },
    onClear() {
      this.pending = []
      this.applied = []
      if (this.params && this.params.filterChangedCallback) this.params.filterChangedCallback()
    },
    onSelectAll() { this.pending = this.options.slice() },
    onSelectNonZero() { this.pending = this.options.filter(function(v){ return v !== 0 }) }
  }
}
</script>
